<template>
    <div id="assignedUser">
        <a-modal
                title="Assigned User"
                :visible="assignedUserVis"
                @cancel="() => (assignedUserVis = !assignedUserVis)"
        >
            <template slot="footer">
                <a-button type="danger" size="small" @click="assignedReset">Reset</a-button>
                <a-button type="primary" size="small" @click="assignedSave">Save</a-button>
            </template>

            <a-form :form="assignedFrom">
                <a-form-item label="User" v-bind="formItemLayout">
                    <a-select
                            show-search 
                             option-filter-prop="children" 
                             :filter-option="filterOption"
                            allowClear
                            size="small"
                            style="width: 85%"
                            v-decorator="[
                              'user',
                              {
                                  rules: [{ required: true, message: $t('publicLang.Required')}]
                              },
                            ]">
                        <a-select-option  :label="item.displayName"   v-for="item in userArr" :key="item.uid" :value="item.uid">{{item.loginAccount}}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>

    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                assignedUserVis: false,
                assignedFrom:  this.$form.createForm(this), // add project generic from
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                assignedUserArr: [],
                userArr: [],
                scHeaderUid: '',
                nowTabIndex: ''
            }
        },
        created() {
            this.init();
            // 将可以用来设置的数据查出来
            ajax.get(api.INVENTORYCYCLECOUNTASSIGNEDUSERLIST).then(
                res => {
                    if (res.code == 200) {
                        this.userArr = res.data
                    } else {
                        this.$customMessage.warning('Failed to obtain assigned user list.');
                    }
                }
            )
        },
        methods:{
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            show(uid,assignedUserArr,nowTabIndex){
                this.assignedUserVis = true
                this.scHeaderUid = uid
                this.assignedUserArr = assignedUserArr
                this.nowTabIndex = nowTabIndex
                this.init()
            },
            cancel(){
                this.assignedUserVis = false
            },
            init(){
                let params = {
                    scHeaderUid: this.scHeaderUid,
                    assignedUserVis: this.assignedUserVis,
                    assignedUserArr: this.assignedUserArr,
                    nowTabIndex: this.nowTabIndex
                }
            },
            assignedReset(){
                this.assignedFrom.resetFields()
            },
            assignedSave(){
                this.assignedFrom.validateFields((err, values) => {
                    if(!err) {
                        let paramsData = [];
                        let userUidObj = {};
                        userUidObj.key = "userUid";
                        userUidObj.value = values.user;
                        paramsData.push(userUidObj);
                        for( let index in this.assignedUserArr ) {
                            let assignedListObj = {};
                            assignedListObj.key = "assignedList";
                            assignedListObj.value = this.assignedUserArr[index];
                            paramsData.push(assignedListObj);
                        }
                        
                        let params = {
                            params: paramsData,
                            language: this.lang
                        };
                        ajax.post(api.INVENTORYCYCLECOUNTUPDATEASSIGNEDUSER, params).then(res => {
                            if (!res) {
                                return;
                            }
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                            }else{
                                this.$customMessage.warning(res.msg)
                            }
                            this.assignedUserVis = false
                            this.$parent.tabData(this.nowTabIndex);
                        })
                    }
                }).catch(function(error) {
                    alert(error);
                })
            }
        }
    }
</script>